// components/CancelConfirmationPopup.jsx
import React from "react";
import { useTheme } from "../../../context/ThemeContext";
import Cross from "../../../images/Builder/cross.svg";
import CrossDark from "../../../images/Builder/cross_dark.svg";

const CancelConfirmationPopup = ({
  isOpen,
  onConfirm,
  onCancel,
  message,
  detail,
}) => {
  const { theme } = useTheme();
  return (
    <dialog
      id="cancel_order_modal"
      className={`modal ${isOpen ? "modal-open" : ""}`}>
      <div className="modal-box p-6 rounded-xl text-center bg-modalBg max-w-64">
        <div className="flex flex-col items-center">
          <div className="text-4xl">🤔</div>
          <h3 className="font-medium text-[14px] mt-3 text-p300">
            Cancel Order
          </h3>
          <p className="text-[12px] font-medium text-n500 mt-1 max-w-52">
            {message}
          </p>
          {detail && <p className="text-xs text-n400 mt-2">{detail}</p>}
        </div>

        <div className="flex justify-center gap-3 mt-6">
          <button
            className="border border-n600 px-4 py-2 rounded-lg "
            onClick={onCancel}>
            <img
                src={theme === "dark" ? CrossDark : Cross}
                alt="Execute icon"
                className="w-2 h-2"
              />
          </button>
          <button
            className="bg-swipe-button text-p400 px-4 py-2 rounded-lg w-36 text-sm font-semibold text-[12px] flex items-center justify-center gap-2"
            onClick={onConfirm}>
            <p>Cancel Order</p>
          </button>
        </div>
      </div>
    </dialog>
  );
};

export default CancelConfirmationPopup;
